import { Button, Col, Drawer, Form, Input, InputNumber, message, Row, Select, Spin } from "antd";
import DrawerFormSize from "./DrawerFormSize";
import HandleNotification from "common/Notification";
import { useState } from "react";
import { postData } from "apiServices/common";
import { SIZE_QTY_UPLOAD_ENDPOINT } from "apiServices/API_ENDPOINTS";
import { LoadingOutlined, PaperClipOutlined, UploadOutlined } from "@ant-design/icons";

const DrawerForm = ({ props, open = false, setOpen, useBothStylePo, setPoDetailsData, addNewRow }) => {
  const {
    view,
    poDetailsData,
    purchesList,
    unique_id,
    styleList,
    isArrayAndHasValue,
    dynamicSizeList,
    commaSeparateNumber,
    form,
    aIsEdit,
    setAIsEdit,
    setUniqueId,
  } = props;

  const baseUrl = process.env.REACT_APP_BASE_URL;

  const { Option } = Select;
  const [csvImportLoading, setCsvImportLoading] = useState(false);

  const onClose = () => {
    if (!aIsEdit) {
      const poDetailsDataCopy = [...poDetailsData];
      poDetailsDataCopy.splice(unique_id, 1);
      setPoDetailsData(poDetailsDataCopy);
    }

    setOpen(false);
    form.resetFields();
  };

  const checkOrderQuantityMoreThan = (list) => {
    const sameStyle = list.filter((item) => item.style_id === list[unique_id].style_id);

    const orderQuantity = parseInt(list[unique_id].order_quantity);

    const totalQuantity = sameStyle?.reduce((acc, item) => {
      return (
        acc +
        item?.sizes?.reduce((acc, size) => {
          return acc + size.sales_order_quantity;
        }, 0)
      );
    }, 0);

    // if (totalQuantity > orderQuantity) {
    //   message.error("Order Quantity is more than Style Quantity");
    //   return true;
    // }
  };

  const applyFormValuesToPoDetails = (formValues) => {
    const poDetailsDataCopy = structuredClone(poDetailsData);
    const foundPoItem = poDetailsDataCopy?.find((item) => item?.unique_id === unique_id);

    if (!foundPoItem) return;

    if (formValues.original_po !== undefined) {
      foundPoItem.original_po = formValues.original_po;
      const foundPoItemOriginal = purchesList.find((item) => item.original_po === formValues.original_po);
      if (foundPoItemOriginal) {
        foundPoItem.internal_po = foundPoItemOriginal.internal_po;
        foundPoItem.po_map_id = foundPoItemOriginal.id;
        foundPoItem.delivery_date = foundPoItemOriginal.delivery_date || null;
      }
    }

    if (formValues.internal_po !== undefined) {
      foundPoItem.internal_po = formValues.internal_po;
      const foundPoItemInternal = purchesList.find((item) => item.internal_po === formValues.internal_po);
      if (foundPoItemInternal) {
        foundPoItem.original_po = foundPoItemInternal.original_po;
        foundPoItem.po_map_id = foundPoItemInternal.id;
        foundPoItem.delivery_date = foundPoItemInternal.delivery_date || null;
      }
    }

    if (formValues.style_id !== undefined) {
      const foundStyle = styleList?.find(
        (item) => item?.style_info?.id === formValues.style_id || item?.style_id === formValues.style_id,
      );
      if (foundStyle) {
        const foundStyleInfo = foundStyle?.style_info;
        foundPoItem.style = foundStyleInfo;
        foundPoItem.style_id = foundStyleInfo?.id;
        foundPoItem.order_quantity = foundStyle?.order_quantity;
        foundPoItem.brand_info = foundStyleInfo?.brand_info;

        const subStyle = foundStyleInfo?.sub_style;
        foundPoItem.color_list_obj = subStyle;
      }
    }

    if (formValues.sub_style_id !== undefined && formValues.style_id !== undefined) {
      const foundStyle = styleList?.find(
        (item) => item?.style_info?.id === formValues.style_id || item?.style_id === formValues.style_id,
      );
      if (foundStyle && foundStyle.style_info) {
        const foundSubStyleInfo = foundStyle.style_info?.sub_style_map?.find(
          (subStyle) => subStyle?.id === formValues.sub_style_id,
        );
        if (foundSubStyleInfo) {
          foundPoItem.sub_style_info = foundSubStyleInfo;
        }
      }
    }

    if (formValues.color_id !== undefined && formValues.style_id !== undefined) {
      const foundStyle = styleList?.find(
        (item) => item?.style_info?.id === formValues.style_id || item?.style_id === formValues.style_id,
      );
      if (foundStyle && foundStyle.style_info) {
        const foundColorInfo = foundStyle.style_info?.color_map?.find(
          (colorItem) => colorItem?.color_info?.id === formValues.color_id,
        );
        if (foundColorInfo) {
          foundPoItem.color = foundColorInfo;
          foundPoItem.color_id = foundColorInfo?.color_info?.id;
        }
      }
    }

    if (formValues.extra_cutting !== undefined) {
      foundPoItem.extra_cutting = formValues.extra_cutting || 0;
    }

    if (!foundPoItem.sizes) {
      foundPoItem.sizes = [];
    }

    if (dynamicSizeList) {
      dynamicSizeList.forEach((size) => {
        const sizeKey = `${size.label}_${size.value}`;
        const sizeValue = formValues[sizeKey];

        if (sizeValue !== undefined && sizeValue !== null) {
          const foundSize = foundPoItem.sizes.find((item) => item.id === size.value);

          if (foundSize) {
            foundSize.sales_order_quantity = sizeValue;
          } else {
            foundPoItem.sizes.push({
              id: size.value,
              name: size.label,
              sales_order_quantity: sizeValue,
              delivery_date: foundPoItem?.delivery_date || poDetailsDataCopy?.[0]?.sizes?.[0]?.delivery_date,
              po_detail_id: foundPoItem?.po_detail_id || 0,
              po_map_id: foundPoItem?.po_map_id,
            });
          }
        }
      });
    }

    if (foundPoItem.po_map_id && foundPoItem.sizes) {
      foundPoItem.sizes = foundPoItem.sizes.map((size) => ({
        ...size,
        po_map_id: foundPoItem.po_map_id,
      }));
    }

    setPoDetailsData(poDetailsDataCopy);
  };

  // Normalize ids so duplicate check works even if data shape varies
  const normalizeIds = (item = {}) => {
    const styleId = item?.style_id || item?.style?.id;
    const subStyleId = item?.sub_style_id || item?.sub_style_info?.id;
    const colorId = item?.color_id || item?.color?.color_info?.id || item?.color?.id;
    const poMapId = item?.po_map_id;
    return { styleId, subStyleId, colorId, poMapId };
  };

  const onFinish = (formValues) => {
    if (checkOrderQuantityMoreThan(poDetailsData)) {
      return;
    }

    if (aIsEdit) {
      const { styleId: style_id, subStyleId: sub_style_id, colorId: color_id } = normalizeIds(formValues);

      const duplicateFound = poDetailsData.some((item) => {
        if (item?.unique_id === unique_id) return false;
        if (item?.is_delete === 1) return false;

        const { styleId, subStyleId, colorId } = normalizeIds(item);

        return styleId === style_id && subStyleId === sub_style_id && colorId === color_id;
      });

      if (duplicateFound) {
        HandleNotification("error", "bottomRight", "Duplicate style, sub style, or color found", null);
        return;
      }

      applyFormValuesToPoDetails(formValues);
    } else {
      //   const isDuplicate = poDetailsData
      //     .map((item, index, items) => {
      //       return `${item?.style_id}_${item?.sub_style_info?.id}_${item?.color_id}`;
      //     })
      //     .some((item, index, items) => items.indexOf(item) !== index);

      //   if (isDuplicate) {
      //     HandleNotification("error", "bottomRight", "Duplicate style, sub style, or color found", null);
      //     return;
      //   }
      // }

      // if (aIsEdit) {
      //   setOpen(false);
      //   setAIsEdit(false);
      //   setUniqueId(0);
      // } else {
      //   addNewRow();
      // }
      let po_map_id = null;
      if (formValues.original_po !== undefined) {
        const foundPoItemOriginal = purchesList.find((item) => item.original_po === formValues.original_po);
        if (foundPoItemOriginal) {
          po_map_id = foundPoItemOriginal.id;
        }
      }
      if (formValues.internal_po !== undefined) {
        const foundPoItemInternal = purchesList.find((item) => item.internal_po === formValues.internal_po);
        if (foundPoItemInternal) {
          po_map_id = foundPoItemInternal.id;
        }
      }

      const { styleId: style_id, subStyleId: sub_style_id, colorId: color_id } = normalizeIds(formValues);

      const duplicateFound = poDetailsData.some((item) => {
        if (item?.unique_id === unique_id) return false;
        if (item?.is_delete === 1) return false;

        const { styleId, subStyleId, colorId, poMapId } = normalizeIds(item);

        return poMapId === po_map_id && styleId === style_id && subStyleId === sub_style_id && colorId === color_id;
      });

      if (duplicateFound) {
        HandleNotification(
          "error",
          "bottomRight",
          "Duplicate style, sub style, or color found in the purchase order details",
          null,
        );
        return;
      }

      // Apply form values to the current row
      applyFormValuesToPoDetails(formValues);
    }

    // Close drawer and reset form for both edit and add cases
    setOpen(false);
    setAIsEdit(false);
    setUniqueId(0);

    form.resetFields();
  };

  const filterOption = (input, option) => {
    return option?.children != null && option.children.toLowerCase().includes(input.toLowerCase());
  };

  const currentStyleId = Form.useWatch("style_id", form);
  const currentStyle = styleList?.find(
    (item) => item?.style_info?.id === currentStyleId || item?.style_id === currentStyleId,
  );
  const currentStyleInfo = currentStyle?.style_info;

  const isSubstyleExists = () => {
    const substyles =
      currentStyleInfo?.sub_style_map ||
      poDetailsData?.find((item) => item?.unique_id === unique_id)?.style?.sub_style_map;
    const isExists = isArrayAndHasValue(substyles) && substyles?.some((item) => item?.sub_style_no);
    return isExists || false;
  };

  const importFromCSV = async (file) => {
    if (!file) {
      message.error("Please select a CSV file");
      return;
    }

    if (!file.name.toLowerCase().endsWith(".csv")) {
      message.error("Please select a valid CSV file");
      return;
    }

    try {
      setCsvImportLoading(true);
      const formData = new FormData();
      formData.append("csv_file", file);
      formData.append("type", "Sizewise Break Down");

      if (unique_id !== undefined) {
        formData.append("unique_id", unique_id);
      }

      const response = await postData(SIZE_QTY_UPLOAD_ENDPOINT, formData);

      if (response && response.status === "success") {
        message.success("CSV imported successfully");

        const { details } = response.data;
        const formValues = {};

        const sortedSizeList = [...(dynamicSizeList || [])].sort((a, b) => {
          const aLabel = a.label?.toString().toLowerCase().trim() || "";
          const bLabel = b.label?.toString().toLowerCase().trim() || "";
          return bLabel.length - aLabel.length;
        });

        const sizeUpdates = [];

        details.forEach((item) => {
          const csvName = item.name?.toString().toLowerCase().trim();
          let matchingSize = null;

          matchingSize = sortedSizeList?.find((size) => {
            const sizeLabel = size.label?.toString().toLowerCase().trim();
            const sizeValue = size.value?.toString().toLowerCase().trim();
            const labelValuePattern = `${sizeLabel}_${sizeValue}`;

            return csvName === sizeLabel || csvName === sizeValue || csvName === labelValuePattern;
          });

          if (!matchingSize) {
            matchingSize = sortedSizeList?.find((size) => {
              const sizeLabel = size.label?.toString().toLowerCase().trim();
              const sizeValue = size.value?.toString().toLowerCase().trim();

              if (sizeLabel) {
                const labelRegex = new RegExp(`\\b${sizeLabel.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\b`, "i");
                if (labelRegex.test(csvName)) return true;
              }

              if (sizeValue) {
                const valueRegex = new RegExp(`\\b${sizeValue.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\b`, "i");
                if (valueRegex.test(csvName)) return true;
              }

              return false;
            });
          }

          if (!matchingSize) {
            matchingSize = sortedSizeList?.find((size) => {
              const sizeLabel = size.label?.toString().toLowerCase().trim();
              const sizeValue = size.value?.toString().toLowerCase().trim();

              if (sizeLabel && csvName.includes(sizeLabel)) return true;
              if (sizeValue && csvName.includes(sizeValue)) return true;
              if (sizeValue && csvName.endsWith(sizeValue)) return true;

              return false;
            });
          }

          if (matchingSize) {
            const fieldName = `${matchingSize.label}_${matchingSize.value}`;
            formValues[fieldName] = parseInt(item.sales_order_quantity) || 0;

            sizeUpdates.push({
              matchingSize,
              sales_order_quantity: item.sales_order_quantity,
            });
          }
        });

        if (Object.keys(formValues).length > 0) {
          form.setFieldsValue(formValues);
        }
      } else {
        message.error(response?.message || "Failed to import CSV");
      }
    } catch (error) {
      message.error("Error occurred while importing CSV");
    } finally {
      setCsvImportLoading(false);
    }
  };

  return (
    <>
      <Drawer
        title="Create a new PO Style"
        width={720}
        onClose={onClose}
        open={open}
        styles={{ body: { paddingBottom: 80 } }}
        maskClosable={false}
      >
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Row gutter={[8, 8]}>
            <Col className="gutter-row" span={useBothStylePo === "No" ? 0 : 12} hidden={useBothStylePo === "No"}>
              <Form.Item
                label="Internal PO"
                name="internal_po"
                rules={[
                  {
                    required: useBothStylePo === "No" ? false : true,
                    message: "Please Select Internal PO!",
                  },
                ]}
                style={{ marginBottom: "unset" }}
              >
                <Select
                  className="w-100"
                  showSearch
                  disabled={view}
                  dropdownStyle={{ minWidth: 250 }}
                  optionFilterProp="children"
                  placeholder="Select an Internal PO"
                  size="small"
                  onChange={(value) => {
                    purchesList?.forEach((item) => {
                      if (item.internal_po === value) {
                        form.setFieldsValue({
                          original_po: item.original_po,
                        });
                      }
                    });
                  }}
                  filterOption={(input, option) => filterOption(input, option)}
                >
                  {purchesList?.length &&
                    purchesList.map((sup, index) => (
                      <Option value={sup.internal_po || undefined} key={`internal_po_key_${index}`}>
                        {sup.internal_po}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={useBothStylePo === "No" ? 0 : 12} hidden={useBothStylePo === "No"}>
              <Form.Item
                label={"Original PO"}
                name={"original_po"}
                rules={[
                  {
                    required: useBothStylePo === "No" ? false : true,
                    message: "Please Select Original PO!",
                  },
                ]}
                style={{ marginBottom: "unset" }}
              >
                <Select
                  className="w-100"
                  showSearch
                  disabled={view}
                  dropdownStyle={{ minWidth: 250 }}
                  optionFilterProp="children"
                  placeholder="Select an Original PO"
                  size="small"
                  onChange={(value) => {
                    purchesList?.forEach((item) => {
                      if (item.original_po === value) {
                        form.setFieldsValue({
                          internal_po: item.internal_po,
                        });
                      }
                    });
                  }}
                  filterOption={(input, option) => filterOption(input, option)}
                >
                  {purchesList?.length &&
                    purchesList.map((sup, index) => {
                      return (
                        <Option value={sup?.original_po || undefined} key={`original_po_key_${index}`}>
                          {sup?.original_po}
                        </Option>
                      );
                    })}
                </Select>
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={12}>
              <Form.Item
                rules={[
                  {
                    required: false,
                    message: "Please Select Style NO!",
                  },
                ]}
                style={{ marginBottom: "unset" }}
                label={"Style"}
                name="style_id"
              >
                <Select
                  dropdownStyle={{ minWidth: 350 }}
                  onChange={(value) => {
                    const foundStyle = styleList?.find((item) => item?.style_id === value);
                    const foundStyleInfo = foundStyle?.style_info;

                    form.setFieldsValue({
                      color_id: foundStyleInfo?.color_map[0]?.color_id,
                      sub_style_id: foundStyleInfo?.sub_style_map[0]?.id,
                      brand: foundStyleInfo?.brand_info?.name,
                    });
                  }}
                  className="w-100"
                  showSearch
                  placeholder="Select a style"
                  optionFilterProp="children"
                  disabled={view}
                  size="small"
                >
                  {isArrayAndHasValue(styleList) &&
                    styleList.map((styleItem, index) => {
                      return (
                        <Option
                          value={styleItem?.style_id || styleItem?.style_info?.id || undefined}
                          key={`style_id_key_${index}`}
                        >
                          {`${styleItem?.style_info?.style_no || ""}${styleItem?.style_info?.description ? ":" : ""}${
                            styleItem?.style_info?.description || ""
                          }`}
                        </Option>
                      );
                    })}
                </Select>
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={isSubstyleExists() ? 12 : 0}>
              <Form.Item
                name="sub_style_id"
                rules={[
                  {
                    required: false,
                    message: "Please select substyle",
                  },
                ]}
                style={{ marginBottom: "unset" }}
                label="Sub Style"
                hidden={isSubstyleExists() ? false : true}
              >
                <Select
                  name="sub_style_id"
                  dropdownStyle={{ minWidth: 350 }}
                  onChange={(value) => {}}
                  className="w-100"
                  showSearch
                  placeholder="Select Substyle"
                  optionFilterProp="children"
                  filterOption={(input, option) => {
                    if (option?.children != null) {
                      return option.children.toLowerCase().includes(input.toLowerCase());
                    }
                  }}
                  disabled={view}
                  size="small"
                >
                  {isArrayAndHasValue(
                    currentStyleInfo?.sub_style_map ||
                      poDetailsData?.find((item) => item?.unique_id === unique_id)?.style?.sub_style_map,
                  ) &&
                    (
                      currentStyleInfo?.sub_style_map ||
                      poDetailsData?.find((item) => item?.unique_id === unique_id)?.style?.sub_style_map
                    )?.map((subStyle, index) => {
                      return (
                        <Option value={subStyle?.id || undefined} key={subStyle?.id}>
                          {subStyle?.sub_style_no || subStyle?.color_info?.name}
                        </Option>
                      );
                    })}
                </Select>
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={12}>
              <Form.Item
                name={"color_id"}
                rules={[
                  {
                    required: false,
                    message: "Please Select Color",
                  },
                ]}
                style={{ marginBottom: "unset" }}
                label={"Color"}
              >
                <Select
                  name={"color_id"}
                  dropdownStyle={{ minWidth: 350 }}
                  onChange={(value) => {}}
                  className="w-100"
                  showSearch
                  placeholder="Select an Style No"
                  optionFilterProp="children"
                  filterOption={(input, option) => {
                    if (option?.children != null) {
                      return option.children.toLowerCase().includes(input.toLowerCase());
                    }
                  }}
                  disabled={view}
                  size="small"
                >
                  {isArrayAndHasValue(
                    currentStyleInfo?.color_map ||
                      poDetailsData?.find((item) => item?.unique_id === unique_id)?.style?.color_map,
                  ) &&
                    (
                      currentStyleInfo?.color_map ||
                      poDetailsData?.find((item) => item?.unique_id === unique_id)?.style?.color_map
                    )?.map((colorItem, index) => {
                      return (
                        <Option value={colorItem?.color_info?.id || undefined} key={colorItem?.color_info?.id}>
                          {colorItem?.color_info?.name}
                        </Option>
                      );
                    })}
                </Select>
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={12}>
              <Form.Item name="brand" style={{ marginBottom: "unset" }} label="Brand">
                <Input size="small" disabled />
              </Form.Item>
            </Col>
            <Col className="gutter-row" span={12}>
              <Form.Item
                label={"Extra Cutting"}
                name={`extra_cutting`}
                rules={[{ required: true, message: "Please Insert Extra Cutting!" }]}
                style={{ marginBottom: "unset" }}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  disabled={view}
                  precision={2}
                  size="small"
                  onChange={(value) => {}}
                  placeholder="Extra Cutting (Required)"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Col span={12}>
              <Form.Item colon={false} style={{ marginTop: "12px" }}>
                <input
                  type="file"
                  id="file-input-bom"
                  hidden
                  accept=".csv"
                  onChange={(e) => importFromCSV(e.target.files[0])}
                  onClick={(e) => {
                    e.target.value = null;
                  }}
                />
                <Button
                  icon={csvImportLoading ? <LoadingOutlined style={{ fontSize: 16 }} spin /> : <UploadOutlined />}
                  type="primary"
                  size="small"
                  onClick={() => document.getElementById("file-input-bom").click()}
                  loading={csvImportLoading}
                >
                  Import from CSV
                </Button>
              </Form.Item>
            </Col>

            <Col span={12}>
              <a
                href={`${baseUrl}/${`storage/CsvUpload/template_style_wise size_break_down.csv`}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ fontSize: "16px", color: "#1890ff" }}
              >
                <PaperClipOutlined /> Download Template
              </a>
            </Col>
          </Row>

          {isArrayAndHasValue(dynamicSizeList) && (
            <Spin spinning={csvImportLoading}>
              <DrawerFormSize view={view} dynamicSizeList={dynamicSizeList} commaSeparateNumber={commaSeparateNumber} />
            </Spin>
          )}
          <Row gutter={8} className="mt-4">
            <Col span={12}>
              <Button style={{ width: "100%" }} type="primary" htmlType="submit" size="small">
                {aIsEdit ? `Update` : `Add`}
              </Button>
            </Col>
            <Col span={12}>
              <Button style={{ width: "100%" }} type="danger" size="small" onClick={onClose}>
                Cancel
              </Button>
            </Col>
          </Row>
        </Form>
      </Drawer>
    </>
  );
};

export default DrawerForm;
